import {
    AUDIENCE,
    CHECKOUT,
    EDIT_NEW_PROJECT,
    LAUNCH_PROJECT,
    MAIN_ROUTE,
    MANAGE_ACCOUNTS,
    MANAGE_PROFILE,
    MEDIA_LIBRARY,
    NEW_OPTION_PACK,
    NEW_PROJECT,
    OPTION_PACKS,
    PREVIEW,
    PROJECT,
    PROJECTS,
    PROJECT_SELECTION,
    QUESTIONS,
    QUESTION_LIBRARY,
    AI_CODING
} from '../constants/routes';
export const SITE_TITLE_MAPPING = (userName) => ({
    [MAIN_ROUTE]: `Hello, ${userName}!`,
    [PROJECT]: `Hello, ${userName}!`,
    [MANAGE_PROFILE]: 'Account Management',
    [MANAGE_ACCOUNTS]: 'Account Management',
    [AI_CODING]: `Hello, ${userName}!`
});

export const PROJECT_SUBTITLE_MAPPING = {
    [MAIN_ROUTE]: 'Welcome to inca',
    [PROJECTS]: 'Project Directory',
    [AI_CODING]: 'inca AI Coding Directory',

    [PROJECT_SELECTION]: 'Create a Project',
    [NEW_PROJECT]: 'New Project',
    [EDIT_NEW_PROJECT]: 'Project Overview',
    [AUDIENCE]: 'Target Audience',
    [QUESTIONS]: 'Question Builder',
    [PREVIEW]: 'Project Preview',
    [CHECKOUT]: 'Checkout',
    [LAUNCH_PROJECT]: 'Project Launch',

    [MEDIA_LIBRARY]: 'Media Library',
    [OPTION_PACKS]: 'Option Pack Library',
    [QUESTION_LIBRARY]: 'Question Library',
    [NEW_OPTION_PACK]: 'New Option Pack',

    [MANAGE_PROFILE]: 'Manage Profile',
    [MANAGE_ACCOUNTS]: 'Manage Subscription'
};

export const PROJECT_SUBTITLE_MAPPING_WIZARD = {
    [MAIN_ROUTE]: 'Welcome to inca',
    [PROJECTS]: 'Project Directory',
    [AI_CODING]: 'AI Coding Directory',

    [PROJECT_SELECTION]: 'Rapid Solutions',
    [NEW_PROJECT]: 'New Project',
    [EDIT_NEW_PROJECT]: 'Project Overview',
    [AUDIENCE]: 'Target Audience',
    [QUESTIONS]: 'Question Builder',
    [PREVIEW]: 'Project Preview',
    [CHECKOUT]: 'Checkout',
    [LAUNCH_PROJECT]: 'Project Launch',

    [MEDIA_LIBRARY]: 'Media Library',
    [OPTION_PACKS]: 'Option Pack Library',
    [QUESTION_LIBRARY]: 'Question Library',
    [NEW_OPTION_PACK]: 'New Option Pack',

    [MANAGE_PROFILE]: 'Manage Profile',
    [MANAGE_ACCOUNTS]: 'Manage Subscription'
};
